// THE unifier — one row for people, activity/leaderboard and shop. Today those
// are three separate layouts; here they're one component with three slots:
//   rank?   — optional mono rank number (leaderboard)
//   lead    — leading visual (Avatar / Lead icon-box)
//   title + meta — the text stack (meta optional)
//   trailing — contextual right slot (chevron, points, price button…)
// Rows sit inside <List> and are divided by a single hairline. Set `onClick`
// to make the whole row a button.
export function List({ className = "", style, children, ...rest }) {
  return <div className={`bz-list ${className}`.trim()} style={style} {...rest}>{children}</div>;
}

export function ListRow({ rank, lead, title, meta, trailing, onClick, className = "", ...rest }) {
  // Always a div — a clickable row (onClick) becomes role="button" rather than a
  // real <button>, so it can legally contain interactive trailing controls
  // (e.g. a CheckButton) without nesting buttons. Those controls should
  // stopPropagation to avoid also firing the row click.
  const cls = `bz-row${onClick ? " bz-row--button" : ""} ${className}`.trim();
  const act = onClick
    ? { role: "button", tabIndex: 0, onClick, onKeyDown: (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); } } }
    : {};
  return (
    <div className={cls} {...act} {...rest}>
      {rank != null && <span className="bz-row__rank">{rank}</span>}
      {lead}
      <div className="bz-row__body">
        <div className="bz-row__title">{title}</div>
        {meta != null && <div className="bz-row__meta">{meta}</div>}
      </div>
      {trailing}
    </div>
  );
}

// Leading slot — a tinted icon box. shape: circle (default, v25 §10.2) | rounded.
// tone: default (neutral well) | brand (brand tint) | outline (surface + hairline).
// size: md (40, default) | sm (34). Pass a BuzerIcon (or any node) as children.
export function Lead({ shape = "circle", tone = "default", size = "md", style, children }) {
  const cls = [
    "bz-lead",
    shape === "circle" ? "bz-lead--circle" : "bz-lead--rounded",
    size === "sm" && "bz-lead--sm",
    tone === "brand" && "bz-lead--brand",
    tone === "outline" && "bz-lead--outline",
  ].filter(Boolean).join(" ");
  return <div className={cls} style={style}>{children}</div>;
}

// Coloured initial avatar. `tone` = any CSS colour (per-person hue).
export function Avatar({ initial, tone = "var(--brand-primary)", style }) {
  return <div className="bz-avatar" style={{ background: tone, ...style }}>{initial}</div>;
}
